export default {
      id: "circle__shown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__shown",
      toString: function () {
        return this.url;
      }
    }